import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { BaseEventTracking } from '@/modules/core/app/models/abstracts/BaseEventTracking';

export class SupportChatflowClickedEventTracking extends BaseEventTracking {
  static eventName: SegmentEvent = SegmentEvent.SUPPORT_CHATFLOW_CLICKED;
  step_id?: string;

  constructor(eventProperties: Partial<SupportChatflowClickedEventTracking>) {
    super();
    this.step_id = eventProperties.step_id;
  }
}
